// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { recentWishListsStyles } from "@gcg/Overrides/Widgets/Common/RecentWishLists";
import { resolveColor } from "@insite/mobius/utilities";
import { css } from "styled-components";

recentWishListsStyles.simpleViewStyles = {
    viewAll: css`
        margin-top: 5px;
        //XNG-Change delete text-decoration
    `,
    topWrapper: css`
        display: flex;
        flex-direction: column;
    `,
    noWishlistsFoundMessage: css`
        display: flex;
        width: 100%;
        align-items: center;
    `,
    title: css`
        font-weight: bold;
        margin: 10px 0;
        font-size: 18px;
        color: ${props => resolveColor("text.main", props.theme)};
    `,
};
